/*
 * @Description: 自营车辆
 * @Author: liuzhonghui
 * @Date: 2025-05-14 17:52:27
 * @LastEditTime: 2025-05-14 17:52:27
 * @LastEditors: liuzhonghui
 */
// 引入api请求方法

import { aiOwnVehicleList } from '@/api/waybillAI';
//aiOwnVehicleList
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'input',
      param: 'plateNumber',
      value: '',
      valueType: 'string',
      label: '自营车牌号',
      placeholder: '请输入',
      clearable: true,
    },
  ],
  // tabs筛选项
  isSpecialTabs: false,
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '自营车牌号',
        prop: 'plateNumber',
        width: 140,
        checked: 1,
        sortable: true,
      },
      {
        label: '操作',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
  },
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.style !== 'casccader' && item.value) {
        if (item.multiple) {
          if (item.value.length > 0) {
            params[item.param] = item.value.toString();
          }
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
      if (item.style === 'casccader' && item.value.length > 0) {
        params[item.params[0]] = item.value[0] ? `${item.value[0]}` : '';
        params[item.params[1]] = item.value[1] ? `${item.value[1]}` : '';
        params[item.params[2]] = item.value[2] ? `${item.value[2]}` : '';
      }
    });

    params.businessId = localStorage.getItem('aicurrentData') || localStorage.getItem('aiBid');
    console.log('getList', context.state.postParams);
    const { data } = await aiOwnVehicleList(Object.assign({}, params, context.state.postParams));
    data.list = data.records;
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    return data.records;
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    console.log('updateValueFromIndex', payload);
    state.parameters[payload.index].value = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
